import { Dayjs } from 'dayjs';
import type { BaseEntity } from './BaseEntity';

export interface OverheadCostLineItem extends BaseEntity {
  description: string;
  totalCost: number;
  isActive: boolean;
  totalAnnualCost?: number;
  annualCostDivisor?: number;
  annualCostMultiplier?: number;
  dateTimePurchased?: Dayjs | null;
  dateTimeDue?: Dayjs | null;
  dateTimePaid?: Dayjs | null;
  recipient?: string;
  notes?: string;
}

type ValidationResult = { issues: { message: string; path: (keyof OverheadCostLineItem)[] }[] };

export function validate(overheadCostLineItem: Partial<OverheadCostLineItem>): ValidationResult {
  let issues: ValidationResult['issues'] = [];

  if (!overheadCostLineItem.description) {
    issues = [...issues, { message: 'Description is required', path: ['description'] }];
  }

  if (!overheadCostLineItem.totalCost) {
    issues = [...issues, { message: 'Total cost is required', path: ['totalCost'] }];
  }

  return { issues };
}